const PointType = {
  Point: "Point",
  Machine: "Machine",
  Epaka: "Epaka",
  PointAndEpaka: "PointAndEpaka",
};
export default PointType;
